import { Box, Button, IconButton, Popover, Typography } from '@mui/material'
import { MouseEventHandler, useEffect, useRef, useState } from 'react'
import { CSVLink } from 'react-csv'
import { useTranslation } from 'react-i18next'
import { handleDoc, handlePdf } from '../../utils/methods/downloadFiles'
import { DocumentFormat, ObjectGeneric } from '../../utils/types/generals'
import { useStyles } from './style'
import { icons } from '../../utils/icons'
import SnackSimple from '../snackbars/simple'
import { Types } from '../../utils/enums'

interface PropsDownloadFiles {
  row: any[]
  column: any[]
  name?: string
  format?: DocumentFormat
  customeHeader?: any[]
  excludedWord?: boolean
  excludedPdf?: boolean
  valueByArray?: {
    headers: ObjectGeneric
    values: ObjectGeneric[]
  }
  excludeExcel?: any
  excludePdfDoc?: any
  removeMargin?: boolean
  csvText?: any
}
const DownloadFiles = ({ row, column, name, format, customeHeader, valueByArray, excludeExcel, excludePdfDoc, removeMargin, csvText, excludedWord, excludedPdf }: PropsDownloadFiles) => {
  const column2 = customeHeader ?? column
  const columnHeaderByArray = Object.values(valueByArray?.headers ?? {})
  const { t } = useTranslation()
  const styles = useStyles({ removeMargin })
  const refCsv = useRef<any>(null)
  const columnClean: any[] = [...column2, ...columnHeaderByArray]?.filter((item: any) => item.id !== 'action')?.map((item: any) => item.label)
  const headers = column2
    ?.filter((item: any) => item.id !== 'action')
    ?.map((item: any) => ({
      label: item.label,
      key: item.id,
    }))
  const [open, setOpen] = useState(false)
  const [anchor, setAnchor] = useState<EventTarget & HTMLButtonElement>()
  const handleDownload: MouseEventHandler<HTMLButtonElement> = (e) => {
    setAnchor(e.currentTarget)
    setOpen(true)
  }
  const closeDownload = () => {
    setOpen(false)
  }
  let max = 0
  let extraHeader: any[] = []
  let extraBody: any[] = []
  let extraRowWord: any[] = []
  const [download, setDownload] = useState({
    excel: false,
    pdf: false,
    word: false,
  })

  valueByArray?.values?.forEach((item: any, index: number) => {
    let body = {}
    item?.forEach((item2, index2) => {
      let bodyWord = {}
      if (index2 > max) {
        max = index2
      }
      columnHeaderByArray?.forEach((item3) => {
        body = {
          ...body,
          [`${item3?.id}${index2 > 0 ? index2 : ''}`]: item2[item3?.id],
        }
        bodyWord = {
          ...bodyWord,
          [`${item3?.id}`]: item2[item3?.id],
        }
      })
      if (index2 > 0) {
        extraRowWord = [...extraRowWord, bodyWord]
      } else {
        extraRowWord = [...extraRowWord, { ...row[index], ...bodyWord }]
      }
    })
    extraBody = [...extraBody, body]
  })

  new Array(max + 1)?.fill(1)?.forEach((item, index) => {
    columnHeaderByArray?.forEach((itemHeader) => {
      extraHeader = [
        ...extraHeader,
        {
          key: `${itemHeader?.id}${index > 0 ? index : ''}`,
          label: itemHeader?.label,
        },
      ]
    })
  })
  const flattenRows = (rows: any[], parent: any = {}) => {
    let flat: any[] = []
    rows.forEach(row => {
      const { subRows, ...rest } = row
      flat.push({ ...parent, ...rest })
      if (Array.isArray(subRows) && subRows.length > 0) {
        flat = flat.concat(flattenRows(subRows, { ...parent, ...rest }))
      }
    })
    return flat
  }

  const rowClean = (data?: { extraCSV?: any[]; extraWord?: any[] }) => {
    const newRow = !((data?.extraWord?.length ?? 0) > 0) ? row : data?.extraWord || [];
    const flatRows = newRow.some(r => Array.isArray(r?.subRows)) ? flattenRows(newRow) : newRow;
    return flatRows?.map((item: any, index: number) => {
      let obje = {};
      Object.entries({ ...item, ...(data?.extraCSV?.[index] ?? []) })
        .filter(([key]) => key !== 'action')
        ?.forEach(([key, value]: any) => {
          let existValue = value?.text || value?.label || value;
          if (key.toLowerCase().includes("promedio")) {
            existValue = `${Number(existValue).toFixed(2)}%`;
          }

          obje = {
            ...obje,
            [key]: existValue || existValue == 0 ? existValue : 'N/A',
          };
        });
      return obje;
    });
  };


  const ref = useRef<NodeJS.Timeout | null>(null)

  const handlePdfDownload = () => {
    handleMessage()
    handleStateDownload('pdf', true)
    const newRow = !(extraRowWord?.length > 0) ? row : extraRowWord || []
    handlePdf(
      columnClean.filter((e) => !excludePdfDoc?.includes(e)),
      newRow.map((item: any) =>
        [...headers, ...columnHeaderByArray].map((itemC: any) => {
          const existValue = item[itemC.key]?.text || item[itemC.key]?.label || item[itemC.key]
          const allText = existValue || existValue == 0 ? existValue : 'N/A'

          return typeof allText === 'string'
            ? allText
              ?.split(' ')
              ?.map((item: any) => {
                if (typeof item === 'string' && item.length > 25) {
                  return item
                    .split('')
                    .map((items: any, index: number) => {
                      if (index % 25 === 0 && index !== 0) {
                        return items + '\n'
                      }
                      return items
                    })
                    .join('')
                }
                return item
              })
              ?.join(' ')
            : allText
        })
      ),
      name,
      format,
      t
    )
    handleStateDownload('pdf', false)
  }

  const handleWordDownload = () => {
    handleMessage()
    handleStateDownload('word', true)
    handleDoc(columnClean, rowClean({ extraWord: extraRowWord }), [...column2, ...columnHeaderByArray], name, t)
    handleStateDownload('word', false)
  }

  const handleExcelDownload = () => {
    handleMessage()
    setDownload((prev) => ({
      ...prev,
      excel: true,
    }));
    handleStateDownload('excel', true)
    refCsv?.current?.click?.()
    handleStateDownload('excel', false)
  }

  const handleStateDownload = (file: string, state: boolean) => {
    setDownload((prev) => ({
      ...prev,
      [file]: state,
    }));
  }

  const [openSnackbar, setOpenSnackbar] = useState({
    open: false,
    message: '',
    type: Types.SUCCESS as string,
  })

  const closeOpenSnakbar = () => {
    setOpenSnackbar((prev) => ({
      ...prev,
      open: false,
    }))
  }

  const handleMessage = () => {
    setOpenSnackbar({
      message: t('general.waitAMoment'),
      open: true,
      type: Types.INFO,
    })
    /* clearSnackbar() */
  }

  /* const clearSnackbar = () => {
    if (ref.current) {
      clearTimeout(ref.current)
    }
  } */

  /* ref.current = setTimeout(closeOpenSnakbar, 3000) */

  useEffect(() => {
    if (openSnackbar.open) {
      const timeout = setTimeout(closeOpenSnakbar, 3000)
      return () => clearTimeout(timeout) // Limpiar timeout cuando se desmonte o cierre manualmente
    }
  }, [openSnackbar.open])

  return (
    <Box sx={styles.container({ styleType: false })}>
      <SnackSimple
        close={closeOpenSnakbar}
        open={openSnackbar.open}
        type={openSnackbar.type}
        message={openSnackbar.message}
      />

      <Box sx={styles.hidden}>
        {row.length > 0 ? (
          <CSVLink data={rowClean({ extraCSV: extraBody })} headers={[...headers.filter((e) => !excludeExcel?.includes(e.key)), ...extraHeader]} filename={name}>
            <IconButton ref={refCsv}></IconButton>
          </CSVLink>
        ) : (
          <CSVLink data={[[t('general.notDataTable')]]} filename={name}>
            <IconButton ref={refCsv}></IconButton>
          </CSVLink>
        )}
      </Box>

      <Box sx={{ display: 'flex', justifyContent: 'flex-end', width: '100%' }}>
        <Button variant='text_primary' onClick={handleDownload}>{t('general.download')}</Button>
      </Box>

      <Popover
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'right',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }} anchorEl={anchor} onClose={closeDownload} open={open}>
        <Box sx={styles.buttons}>
          {!excludedPdf &&
            <IconButton
              className='red flex-col'
              disabled={download.pdf}
              onClick={handlePdfDownload}
            >
              {icons('pdf')}

              <Typography variant='footer'>{t('general.pdf')}</Typography>
            </IconButton>
          }
          {!excludedWord &&
            <IconButton
              className='blue flex-col'
              disabled={download.word}
              onClick={handleWordDownload}
            >
              {icons('word')}
              <Typography variant='footer'>{t('general.word')}</Typography>
            </IconButton>
          }

          <IconButton
            className='green flex-col'
            disabled={download.excel}
            onClick={handleExcelDownload}
          >
            {icons('csv')}
            <Typography variant='footer'>{t('general.csv')}</Typography>
          </IconButton>
        </Box>
      </Popover>
    </Box>
  )
}

export default DownloadFiles
